import React from 'react';
import { getLabel } from '../../../../data/labels';
import BetInfo from '../BetInfo';
import EventsList from '../EventsList';
import { getConfiguration } from '../../../utils/configuration';
import { getTicketStatusDescription } from '../../../utils/getTicketStatusDescription';


function SingleBetTicket(props) {
    let descTicket = getLabel('mybets.singola');
    let ticketStatus = null;
    const conf = getConfiguration();
    if (props.infoTicket || conf.dtsch) {
        descTicket = `${descTicket} ${props.ticket.psv ? getLabel('retail.protocol.psv') : getLabel('retail.protocol.psqf')}`;
        ticketStatus = getTicketStatusDescription(props.ticket.status, props.ticket.paidWithCashout);
    }

    return (
        <div className="mybet-container d-flex flex-column | mb_5">
            <div className="d-flex justify-content-space-between align-items-center margine-su-giu bold pointer details-toggle | mb_5_1">
                <span className="text-big bold | mb_5_1_1">{descTicket}</span>
                <span className="margine-sx margin-right-auto | mb_5_1_2">
                    {props.ticket.funBonus &&
                        <span className="cg-mybet-funbonus | mb_5_1_2_1">{getLabel('mybets.funbonus')}</span>
                    }
                    {props.ticket.freeBet &&
                        <span className="cg-mybet-funbonus | mb_5_1_2_2">{getLabel('mybets.freebet')}</span>
                    }
                    {ticketStatus &&
                        <span className="cg-mybet-status-label | mb_5_1_2_3">{ticketStatus.toUpperCase()}</span>
                    }
                </span>
                <span className="visibility-hidden | mb_5_1_3">{descTicket}</span>
            </div>
            <hr className="mb_4" />
            <div className="mybet-events-container | mb_6">
                <EventsList isPsv={props.ticket.psv} events={props.ticket.events} isCheckbet={true} />
            </div>
            <div className="light-grey-bg | mb_5_3">
                <BetInfo isSnapshot={props.isSnapshot} isCheckbet={true} ticket={props.ticket} obfuscateTicketId={props.obfuscateTicketId} />
            </div>
        </div>
    );
}

export default SingleBetTicket;